angular.module('env.device', [])

    .constant('device', {
        isTouch: function () {
            return ('ontouchstart' in window) ||
                //commented because of ie10
                //('onmsgesturechange' in window) ||
                (navigator.MaxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0);
        }
    });